enum FlowNodeType {
    Screen = "ScreenNode",
    TextLabel = "TextLabelNode",
    VariantGroup = "VariantGroupNode",
    Shape = "ShapeNode",
    Placeholder = "PlaceholderNode",
    Annotation = "AnnotationNode"
}

export default FlowNodeType;
